import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {
    auth,
    facebookAuthProvider,
    githubAuthProvider,
    googleAuthProvider,
    twitterAuthProvider
} from "firebase/firebase";
import {
    SIGNIN_FACEBOOK_USER,
    SIGNIN_GITHUB_USER,
    SIGNIN_GOOGLE_USER,
    SIGNIN_TWITTER_USER,
    SIGNIN_USER,
    SIGNOUT_USER,
    SIGNUP_USER,
    REQ_REFRESH_TOKEN,
    REQ_CREATE_TOKEN,
    GET_REFRESH_TOKEN,
    GET_CREATE_TOKEN,
    SET_MENU,
    BASE_URL_APIv5,
    BASE_URL_OSLOG,
} from "constants/ActionTypes";
import {showAuthMessage, userSignInSuccess, userSignOutSuccess, userSignUpSuccess} from "actions/Auth";
import {
    userFacebookSignInSuccess,
    userGithubSignInSuccess,
    userGoogleSignInSuccess,
    userTwitterSignInSuccess
} from "../actions/Auth";

import axios from 'axios'

const createUserWithEmailPasswordRequest = async (email, password) =>
    await  auth.createUserWithEmailAndPassword(email, password)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithEmailPasswordRequest = async (email, password) =>
    await  auth.signInWithEmailAndPassword(email, password)
        .then(authUser => authUser)
        .catch(error => error);

// const signOutRequest = async () =>
//     await  auth.signOut()
//         .then(authUser => authUser)
//         .catch(error => error);


const signInUserWithGoogleRequest = async () =>
    await  auth.signInWithPopup(googleAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithFacebookRequest = async () =>
    await  auth.signInWithPopup(facebookAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithGithubRequest = async () =>
    await  auth.signInWithPopup(githubAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithTwitterRequest = async () =>
    await  auth.signInWithPopup(twitterAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

const signInWithUsernamePasswordApi = async(username, password) => {

    const param = JSON.stringify({username, password})

    return await axios.post(`${BASE_URL_APIv5}/user/login`, param)
                .then((response) =>  response )
                .catch((error) => error.response )
}

const signInWithUsernamePasswordApi2 = async(username, password) => {

    const URL = `${BASE_URL_OSLOG}/embedd/auth?username=${username}&password=${password}&embedd=true`;
    // const URL = `${BASE_URL_OSLOG}/lintasarta/auth?username=${username}&password=${password}&embedd=true`;
    // const URL = `${BASE_URL_OSLOG}/embedd/auth-apikey?apikey=12e70a6f-08ec-4b95-840c-40acb6c9b619&company=323`;
    console.log(URL)

    return await axios({
        headers: {
            'Accept': 'application/json',
        },
        method: 'get',
        url: URL,
        withCredentials: true,
    }).then((response) => response).catch((error) => error.response);

}

const getMenuAfterLogin = async (rolename, token) => {
    // console.log(`token: ${token}`)
    return await axios.get(`${BASE_URL_APIv5}/roles-module-by-name/${rolename}`, {
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    })
                .then((response) =>  response )
                .catch((error) => error.response )
                
}

const signOutRequest = async () =>{ 

    // return await axios.get('http://localhost:9000/logout')
    //         .then((res)=> res)
    
    const URL = `${BASE_URL_OSLOG}/app/logout`;
    // console.log(URL)
    
    await axios({
        headers: {
            'Accept': 'application/json',
        },
        method: 'get',
        url: URL,
        withCredentials: true,
    }).then((response) => response).catch((error) => error.response);

    // await auth.signOut()
    //     .then(authUser => authUser)
    //     .catch(error => error);

    return 'ok';

}

function* createUserWithEmailPassword({payload}) {
    const {email, password} = payload;
    try {
        const signUpUser = yield call(createUserWithEmailPasswordRequest, email, password);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            localStorage.setItem('user_id', signUpUser.user.uid);
            yield put(userSignUpSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

function* signInUserWithGoogle() {
    try {
        const signUpUser = yield call(signInUserWithGoogleRequest);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            localStorage.setItem('user_id', signUpUser.user.uid);
            yield put(userGoogleSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}


function* signInUserWithFacebook() {
    try {
        const signUpUser = yield call(signInUserWithFacebookRequest);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            localStorage.setItem('user_id', signUpUser.user.uid);
            yield put(userFacebookSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}


function* signInUserWithGithub() {
    try {
        const signUpUser = yield call(signInUserWithGithubRequest);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            localStorage.setItem('user_id', signUpUser.user.uid);
            yield put(userGithubSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}


function* signInUserWithTwitter() {
    try {
        const signUpUser = yield call(signInUserWithTwitterRequest);
        if (signUpUser.message) {
            if (signUpUser.message.length > 100) {
                yield put(showAuthMessage('Your request has been canceled.'));
            } else {
                yield put(showAuthMessage(signUpUser.message));
            }
        } else {
            localStorage.setItem('user_id', signUpUser.user.uid);
            yield put(userTwitterSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

function* signInUserWithEmailPassword({payload}) {
    const {email, password} = payload;
    try {
        
        const signInUserApi = yield call(signInWithUsernamePasswordApi, email, password);
        const signInUserApi2 = yield call(signInWithUsernamePasswordApi2, email, password)
        // console.log("sign in oslog 4",signInUserApi2);
        if(signInUserApi)
            if (signInUserApi.data.status !== true) {
                yield put(showAuthMessage(signInUserApi.data.message));
            } else {
                const {role_name, apikey} = signInUserApi.data.data
                const menu = yield call(getMenuAfterLogin, role_name, apikey)
                // console.log(menu)
                if (menu.data.status === true){
                    const {data_modules} = menu.data.data
                    // console.log(data_modules)
                    const data_menu = JSON.stringify(data_modules)
                    yield put({type: SET_MENU, payload: data_modules})
                    localStorage.setItem('menu_user', data_menu);
                    localStorage.setItem('user_id', signInUserApi.data.data.id);
                    localStorage.setItem('apiKey', signInUserApi.data.data.apikey);
                    localStorage.setItem('rolename', signInUserApi.data.data.role_name);
                    localStorage.setItem('name', signInUserApi.data.data.fullname);
                    localStorage.setItem('companyId', signInUserApi.data.data.company);
                    localStorage.setItem('package', signInUserApi.data.data.package_name);
                    yield put(userSignInSuccess(signInUserApi));
                } else {
                    yield put(showAuthMessage(menu.data.message))
                }
            }
        else 
            yield put(showAuthMessage("Oops! can't connected to server"));
            
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

function* signOut() {
    try {
        const signOutUser = yield call(signOutRequest);
        // console.log(signOutUser)
        if (signOutUser !== 'ok') {
            yield put(showAuthMessage(signOutUser.message));
        } else {
            // console.log('run signout')
            localStorage.removeItem('user_id');
            localStorage.removeItem('apiKey');
            localStorage.removeItem('rolename');
            localStorage.removeItem('name');
            localStorage.removeItem('menu_user');
            localStorage.removeItem('companyId');
            yield put(userSignOutSuccess(signInUser));
        }
    } catch (error) {
        console.log("error login")
        yield put(showAuthMessage(error));
    }
}

function* setRefreshToken(data) {
    const {username, password} = data.action
    try {
        // console.log(data)
        // console.log(`username: ${username}, password: ${password}`)
    } catch (error) {
        // console.log(error)
    }
}

function* setCreateToken() {
    try {
        // console.log('create token')
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

export function* createUserAccount() {
    yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
}

export function* signInWithGoogle() {
    yield takeEvery(SIGNIN_GOOGLE_USER, signInUserWithGoogle);
}

export function* signInWithFacebook() {
    yield takeEvery(SIGNIN_FACEBOOK_USER, signInUserWithFacebook);
}

export function* signInWithTwitter() {
    yield takeEvery(SIGNIN_TWITTER_USER, signInUserWithTwitter);
}

export function* signInWithGithub() {
    yield takeEvery(SIGNIN_GITHUB_USER, signInUserWithGithub);
}

export function* signInUser() {
    yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
    yield takeEvery(SIGNOUT_USER, signOut);
}

export function* refreshToken() {
    yield takeEvery(REQ_REFRESH_TOKEN, setRefreshToken);
}

export function* createToken() {
    yield takeEvery(REQ_CREATE_TOKEN, setCreateToken);
}

export default function* rootSaga() {
    yield all([fork(signInUser),
        fork(createUserAccount),
        fork(signInWithGoogle),
        fork(signInWithFacebook),
        fork(signInWithTwitter),
        fork(signInWithGithub),
        fork(refreshToken),
        fork(createToken),
        fork(signOutUser)]);
}


// WEBPACK FOOTER //
// ./sagas/Auth.js